import { PerformanceDatapoint } from 'owa-analytics';
import type { DatapointOptions } from 'owa-analytics-types';
import { getThreadName } from 'owa-thread-config';
// Note:  this file is used on both the worker side and the main side to track worker bootstrap performance.
// The different contexts will create *different* datapoint objects, with the worker returning its datapoint
// timings to the main side as a basic JS object return value of the initialize method, which the main side
// combines with its own datapoint information via markFromJs.
let initDp: PerformanceDatapoint | undefined;
export enum InitWaterfall {
    LoadFromUrl = 1,
    SD,
    ChannelId,
    Bootstrap_WS,
    Bootstrap_WE,
    Bootstrap_C,
    SyncEventListener,
    Initialize_WS,
    Initialize_W_Settings,
    Initialize_W_Loc,
    Initialize_W_MAcct,
    Initialize_WE,
    Initialize_C,
    Return,
    OfflineSync,
}
export function endDp(): void {
    getDp().end();
    initDp = undefined;
}
export function mark(timing: keyof typeof InitWaterfall): void {
    getDp().addToCustomWaterfall(InitWaterfall[timing], timing);
}
export function addCustomData(data: Record<string, string | number>): void {
    getDp().addCustomData(data);
}
export function getDp(): PerformanceDatapoint {
    if (!initDp) {
        const options: DatapointOptions | undefined =
            getThreadName() === 'DATA_WORKER_THREAD'
                ? {
                      skipNonMetadataTasks: true,
                  }
                : undefined;
        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         *	> Argument at index 1 for PerformanceDatapoint must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        initDp = new PerformanceDatapoint('DataWorker_InitV2', undefined, options);
    }
    return initDp;
}
